import { Box, Typography } from '@mui/material';

import SectionTitle from './SectionTitle';

interface Props {
  disabled?: boolean;
}

const contents = [
  '探視時間',
  '普通探視時間為上午8:00至晚上9:00，但重症監護病房的探視時間有所不同。請與您的護理單位確認具體時間。',
];

const contents2 = [
  '餐飲與營養服務',
  '餐飲與營養服務的員工會於次日的菜單與您的餐盤一起送來。此菜單根據您的醫生所開的飲食方案制定，並提供各種美味且健康的食物。\n您只需圈選您的選擇並將填寫好的菜單放在餐盤上即可。',
  '工作人員會檢查您的選擇是否符合醫生規定的飲食計劃，並隨時與您討論菜單或解答您的疑問。\n如果您需要進一步的協助，所在病區的護理人員將很樂意聯繫餐飲與營養服務部門。',
  '有時，某些醫療檢查可能安排在您的正常用餐時間，或者某些程序需要空腹進行，這可能會導致您的餐食延遲。\n不過，一旦您能夠進食，護理人員會為您訂餐。',
  '餐飲與營養服務團隊包括臨床營養師，他們接受過營養科學、健康維護和患者教育方面的專業培訓。\n我們的營養師為那些最需要額外營養支持的患者提供幫助，同時也可以教導患者有關特殊飲食計劃和飲食限制的知識。\n如果您想了解更多關於您的飲食，請讓您的醫生或護士聯繫營養師。',
  '如果您認為我們可以做得更好，或者您有任何問題或疑慮，請撥打患者餐飲服務幫助熱線：0000-0000。',
];

const contents3 = [
  '個人物品',
  '醫院不提供個人物品的存儲服務。所有個人物品將由患者或家屬負責保管。\n如果患者需要轉移至手術區或重症監護病房，必須將所有物品（包括眼鏡、助聽器、假牙等）從病房中取出。\n如果您需要將物品存放在醫院保險櫃中，請致電入院辦公室：0000-0000。',
];

const contents4 = [
  '退房手續',
  '當您的醫生批准您出院並準備離開時，醫院工作人員會用輪椅護送您離開。',
  '在離開之前，請務必仔細檢查您的病房是否遺留任何個人物品，同時取回您存放在醫院保險櫃中的貴重物品。醫院退房時間為上午11:00。',
  ' 離開前，您必須通過商務辦公室的清算手續：南樓一樓，開放時間為上午8:00至下午4:30，電話：0000-0000。',
];

const TwiceContents = (props: Props) => {
  const { disabled } = props;

  return (
    <>
      <SectionTitle title="在院期間" />

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '12px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents2.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '12px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents2.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents3.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '12px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents3.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <SectionTitle title="出院" />

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents4.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '12px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }

          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
            </Typography>
          );
        })}
      </Box>
    </>
  );
};

export default TwiceContents;
